import { useTranslation } from 'react-i18next'
import { Building2 } from 'lucide-react'
import { Card, CardBody, CardHeader, CardTitle } from '@ludus/ui'

export function CompanyPlaceholder() {
  const { t } = useTranslation()
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('pages.leads.detail.company.title', { defaultValue: 'Company' })}</CardTitle>
      </CardHeader>
      <CardBody className="flex items-center gap-2 text-xs text-muted">
        <Building2 className="h-4 w-4 text-muted/70" aria-hidden="true" />
        <span>
          {t('pages.leads.detail.company.comingSoon', {
            defaultValue: 'Companies entity coming later',
          })}
        </span>
      </CardBody>
    </Card>
  )
}
